module.exports = __webpack_public_path__ + "static/media/assignment_turned.c53a801f.svg";